import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';

import MUITextField from '@mui/material/TextField';

const TextField = forwardRef((props, ref) => {
  const { variant, readOnly, InputProps, ...others } = props;
  return (
    <MUITextField
      inputRef={ref}
      variant={variant}
      {...others}
      color="primary"
      margin="dense"
      InputProps={{
        ...InputProps,
        readOnly,
      }}
    />
  );
});

TextField.propTypes = {
  variant: PropTypes.oneOf(['filled', 'outlined', 'standard']),
  readOnly: PropTypes.bool,
  InputProps: PropTypes.object,
};

TextField.defaultProps = {
  variant: 'standard',
  readOnly: false,
  InputProps: {},
};

export default TextField;
